module.exports = __webpack_public_path__ + "img/Reg-accommodation.a3fe01b8.svg";